import React from 'react'
import './offer.css'
import Common_title from '../../common-components/common-title/Common_title'

const Offer = () => {
    return (
        <>
            <section className='Offer_section'>
                <div className='container'>
                    <Common_title title="OFFERS FOR YOU" subtitle="Our Delighting Offers for You" />

                    <div className='row mt-5'>
                        <div className='col-sm-7  mb-3'>
                            <div className='image_div '>
                                <img className='ofr-img aspp' src={process.env.PUBLIC_URL + '/assets/images/home/offer/banner1.png'} />
                            </div>
                        </div>
                        <div className='col-sm-5'>
                            <div className='image_div mb-3'>
                                <img className='ofr-img' src={process.env.PUBLIC_URL + '/assets/images/home/offer/banner2.png'} />
                            </div>
                            <div className='image_div'>
                                <img className='ofr-img' src={process.env.PUBLIC_URL + '/assets/images/home/offer/banner3.png'} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Offer